import { constant } from "@app/core/constants/constantVariables";

export const environment = {
  production: true,
  authDisable: false,
  authIdToken: '',
  authorizationData: null,
  API_ENDPOINT: constant.prd.APIEndpoint,
  API_KEY: constant.prd.APIKey,
  ASSETS_ENDPOINT: constant.prd.assetsEndpoint,
  region: constant.prd.region,
  userPoolId: constant.prd.userPoolId,
  userPoolWebClientId: constant.prd.userPoolWebClientId,
  authDomain: constant.prd.domain,
  redirectSignIn: constant.prd.redirectSignIn,
  redirectSignOut: constant.prd.redirectSignOut,
  passPhrase: constant.prd.passPhrase,
  name: constant.prd.name,
  environmentName: constant.prd.environment,
  gitProjId: constant.prd.gitProjId,
  gitAccessDetails: constant.prd.gitAccessDetails
};
